import TitleAreaSection from "./../TitleSection";
import WeeklySpecials from "./../WeeklySpecials";
import TestimonialSection from "./../TestimonialSection";
import AboutSection from "./../AboutSection";

function HomePage() {
    return (
        <>
            <TitleAreaSection />
            <WeeklySpecials />
            <TestimonialSection />
            <AboutSection />
        </>
    );
}

export default HomePage;